export enum DialogSize {
   Small = "small",
   Medium = "medium",
   Large = "large"
}